import React from "react";
import { UAParser } from "ua-parser-js";
const parser = new UAParser();
const browserName = parser.getBrowser().name;
export default browserName; 